import { FileHeader, HeaderMapping, PropertyConfig } from '@amzn/awscat-portfolio-assessment-types';
import { Link, RadioGroup, Select, Toggle } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../../common/Localization';
import { OnChangeAsync, OnChangeSync } from '../common-util/types';
import { getUomOptions } from '../common-util/uomConversion';
import { convertNumberToString } from '../common-util/util';

export const MandatoryPropertyColCell = (item: HeaderMapping) => item.portfolioPropertyLabel;

export const FileHeaderColCell = (item: HeaderMapping) => (
    <div>
        {item.fileHeader}
        <span className='preview awsui-util-font-size-0'>{item.uniqueValues}</span>
    </div>
);

export const MeasurementColCell = (item: HeaderMapping, onUomChange: OnChangeSync) => {
    const radioOptions = getUomOptions(item.UOM);
    const onChange = (e: any) => onUomChange(item, e);
    return (item.UOM && radioOptions && !!item.fileHeaderIndex) ? (
        <RadioGroup
            className='radio-group-flat'
            items={radioOptions}
            value={item.fileUOM as string}
            onChange={onChange}
        />
    ) : null;
};

export const OverwriteColCell = (item: HeaderMapping, onOpenOverwriteModal: OnChangeSync, onSwitchOverwriteToggle: OnChangeSync) => {
    const label = <span>{constants.OVERWRITE} </span>;
    const onToggleSwitch = (e: any) => onSwitchOverwriteToggle(item, e);
    const onLinkClick = (e: any) => onOpenOverwriteModal(item, e);
    return (item.isId || !item.overwriteCount) ? null : (
        <div className={'overwrite-col-cell'}>
            <Toggle
                checked={item.overwrite || false}
                onChange={onToggleSwitch}
            >
                {label}
            </Toggle>
            <Link onFollow={onLinkClick}>{`${item.overwriteCount || 0} ${constants.RECORDS}`}</Link>
        </div>
    );
};

export const FileHeaderSelectColCell = (
    item: HeaderMapping,
    fileHeaders: FileHeader[],
    onMandatoryHeaderMappingChange: OnChangeAsync) => {
    const selectedOption = {...fileHeaders[item.fileHeaderIndex || 0], value: convertNumberToString(item.fileHeaderIndex || 0)};
    const onChange = (e: any) => onMandatoryHeaderMappingChange(item, e);
    const options = fileHeaders.map(header => ({...header, value: `${header.id}`}));
    return (
        <div>
            <Select
                className='header-select'
                filteringType='auto'
                onChange={onChange}
                options={options}
                selectedOption={selectedOption}
            />
            <span className='preview awsui-util-font-size-0'>{item.uniqueValues}</span>
        </div>
    );
};

export const OptionalPropertySelectColCell = (
    item: HeaderMapping,
    optionalProperties: PropertyConfig[],
    onOptionalHeaderMappingChange: OnChangeSync) => {
    const selectedOption = optionalProperties.find((optionalProperty: PropertyConfig) => item.portfolioProperty === optionalProperty.value);
    const onChange = (e: any) => onOptionalHeaderMappingChange(item, e);
    return (
        <Select
            className='header-select'
            filteringType='auto'
            onChange={onChange}
            options={optionalProperties}
            selectedOption={selectedOption || {}}
        />
    );
};

export const EmptyState = (
    <div className='awsui-util-t-c'>
        <div className='awsui-util-pt-s awsui-util-mb-xs'>
            <b>{constants.HEADER_MAPPING_EMPTY_TITLE}</b>
        </div>
        <p className='awsui-util-mb-s'>
            {constants.HEADER_MAPPING_EMPTY_MESSAGE}
        </p>
    </div>
);
